<template>
  <VoucherTemplateForm :voucher-template="resource"
                       :setup-complete="setupComplete"
                       :merchant="merchant"
                       :currency-tenants="currencyTenants"
                       :countries="countries"
                       :sequence-numbers="sequenceNumbers"
                       @formSubmit="createFormSubmitted($event, { companyId: merchant.id })" />
</template>

<script>
import store from "./VoucherTemplateStore";
import SequenceNumberStore from "./SequenceNumberStore";
import SetupStore from "@shared/components/Setup/SetupStore";
import CompanyStore from "@shared/components/Company/CompanyStore";
import CountryStore from "../../../dashboard/stores/CountryStore";
import TenantStore from "@tenant_admin/stores/TenantStore";
import VoucherTemplateForm from "./VoucherTemplateForm.vue";
import VoucherTemplateMixin from "./VoucherTemplateMixin";

const responseStore = {
  response: {
    resource: {
      merchant_base_currency: {},
      manual_numbering: true,
      display_line_items: true,
      default_due_date_option: "on_receipt",
      logo: {},
      country: {}
    }
  },

  sequenceNumbers: []
};

const fetchResource = async (to, from, next) => {
  responseStore.currencyTenants = await TenantStore.methods.fetchVisibleCurrencyTenants(
    Dashboard.currentTenant.id,
    CompanyStore.currentCompany.country.id
  );
  responseStore.sequenceNumbers = await SequenceNumberStore.fetchAll(
    { companyId: CompanyStore.currentCompany.id });
  responseStore.countries = await CountryStore.collection("public");

  next();
};

export default {
  name: "VoucherTemplateNew",

  title () {
    return `New Template - ${Dashboard.currentTenant.name}`;
  },

  components: {
    VoucherTemplateForm
  },

  mixins: [VoucherTemplateMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data: function () {
    return {
      store: store,
      setupStoreState: SetupStore.state,
      responseStore: this.$_.cloneDeep(responseStore)
    };
  },

  computed: {
    setupComplete () {
      return this.setupStoreState.stage === 4;
    },

    merchant () {
      return CompanyStore.state.company;
    },

    currencyTenants () {
      return this.responseStore.currencyTenants;
    },

    sequenceNumbers () {
      return this.responseStore.sequenceNumbers.collection;
    },

    countries () {
      return responseStore.countries;
    }
  },

  mounted () {
    this.addBreadcrumb("New Template");
  },

  methods: {
    async createFormSubmitted (e, params) {
      tinyMCE.triggerSave();

      if (this.setupComplete) {
        this.handleResponse(await store.create(params));
      } else {
        this.handleResponseToNew(await store.create(params), this.finishSetup);
      }
    },

    finishSetup (response) {
      if (response.success && !this.setupComplete) {
        CompanyStore.voucherTemplateCompleted();
        SetupStore.finishSetup();
      }
    }
  }
};
</script>
